import { gql } from '@apollo/client';
import type { ApplyGroupRecommendationInput, GroupRecommendation } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

const throwOnErrors = <T extends { errors?: Array<{ message: string }> }>(result: T): T => {
  if (result.errors?.length) {
    throw new Error(`GraphQL mutation errors: ${result.errors.map((e) => e.message).join(', ')}`);
  }
  return result;
};

export class GraphQLGroupRecommendationsRequester {
  /** Lê o que o job persistiu. A geração saiu do caminho de request (AE-2756). */
  public getGroupRecommendations = (fleetId: string): Promise<GroupRecommendation[]> => {
    return graphQLRequester
      .query<{ fleetGroupRecommendations: GroupRecommendation[]; errors?: Array<{ message: string }> }>({
        query: gql`
          query FleetGroupRecommendations($fleetId: ID!) {
            fleetGroupRecommendations(fleetId: $fleetId) {
              id
              fleetId
              suggestedName
              vehicleIds
              reason
              dismissCount
              appliedPayloadJson
            }
          }
        `,
        variables: { fleetId },
      })
      .then((result) => throwOnErrors(result).fleetGroupRecommendations);
  };

  /** Registra a frota para o job agendado visitar. Não gera nada; a user-api responde 204. */
  public touchFleetRecommendations = (fleetId: string): Promise<boolean> => {
    return graphQLRequester
      .mutate<{ touchFleetRecommendations: boolean; errors?: Array<{ message: string }> }>({
        mutation: gql`
          mutation TouchFleetRecommendations($fleetId: ID!) {
            touchFleetRecommendations(fleetId: $fleetId)
          }
        `,
        variables: { fleetId },
      })
      .then((result) => throwOnErrors(result).touchFleetRecommendations);
  };

  public applyGroupRecommendation = (fleetId: string, id: string, input: ApplyGroupRecommendationInput): Promise<GroupRecommendation> => {
    return graphQLRequester
      .mutate<{ applyGroupRecommendation: GroupRecommendation; errors?: Array<{ message: string }> }>({
        mutation: gql`
          mutation ApplyGroupRecommendation($fleetId: ID!, $id: ID!, $input: ApplyGroupRecommendationInput!) {
            applyGroupRecommendation(fleetId: $fleetId, id: $id, input: $input) {
              id
              fleetId
              suggestedName
              vehicleIds
              reason
              dismissCount
              appliedPayloadJson
            }
          }
        `,
        variables: { fleetId, id, input },
      })
      .then((result) => throwOnErrors(result).applyGroupRecommendation);
  };

  public dismissGroupRecommendation = (fleetId: string, id: string): Promise<GroupRecommendation> => {
    return graphQLRequester
      .mutate<{ dismissGroupRecommendation: GroupRecommendation; errors?: Array<{ message: string }> }>({
        mutation: gql`
          mutation DismissGroupRecommendation($fleetId: ID!, $id: ID!) {
            dismissGroupRecommendation(fleetId: $fleetId, id: $id) {
              id
              fleetId
              suggestedName
              vehicleIds
              reason
              dismissCount
              appliedPayloadJson
            }
          }
        `,
        variables: { fleetId, id },
      })
      .then((result) => throwOnErrors(result).dismissGroupRecommendation);
  };
}

export default GraphQLGroupRecommendationsRequester;
